// extracted by mini-css-extract-plugin
export var borderRadius = "_9f-4";
export var large = "_9f-3";
export var logoContainer = "_9f-0";
export var nameLogo = "_9f-2";
export var small = "_9f-1";